export const styles = {
  nav: {
    container: "p-1 mb-1 z-40 bg-white/70 backdrop-blur-sm",
    row: "flex items-center justify-between w-full",
    title: "text-[25px] font-semibold font-ssp",
    right: "flex items-center gap-2",
    refresh: "hover:text-blue-600",
    addBtn: "p-2 hover:bg-blue-600 min-w-[10rem]",
    disableAddBtn: "p-2 hover:bg-gray-300 min-w-[10rem]",
  },

  search: {
    wrapper: "relative w-[300px] bg-gray-100 rounded-full",
    iconLeft: "absolute left-4 top-1/2 -translate-y-1/2 flex items-center",
    iconRight: "absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer",
    input: [
      "w-full h-10 bg-gray-100 rounded-lg",
      "pl-12 pr-12 text-black",
      "placeholder:text-grey-1550 placeholder:text-[13px]",
      "border border-transparent",
      "focus:border-[#e6eeff] focus:outline-none"
    ].join(" "),
  },
};
